import { render, staticRenderFns } from "./HealthBehavior.vue?vue&type=template&id=1824d464&scoped=true"
import script from "./HealthBehavior.vue?vue&type=script&lang=js"
export * from "./HealthBehavior.vue?vue&type=script&lang=js"
import style0 from "./HealthBehavior.vue?vue&type=style&index=0&id=1824d464&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1824d464",
  null
  
)

export default component.exports